import { render, staticRenderFns } from "./NeumaticosEnReparacion.vue?vue&type=template&id=72f1c759"
import script from "./NeumaticosEnReparacion.vue?vue&type=script&lang=js"
export * from "./NeumaticosEnReparacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports